// Slovenian translations
export const sl: Record<string, string> = {
  'menu.dashboard': 'Nadzorna plošča',
  'menu.orderNew': 'Registracija izdelka',
  'menu.customers': 'Stranke',
  'menu.products': 'Izdelki',
  'menu.users': 'Uporabniki',
  'menu.settings': 'Nastavitve',
  'menu.logout': 'Odjava',
  'dashboard.title': 'Nadzorna plošča',
  'dashboard.todaySales': 'Prodaja danes',
  'dashboard.totalOrders': 'Skupaj naročil',
  'dashboard.newOrder': 'Novo naročilo',
  'dashboard.newCustomer': 'Nova stranka',
  'order.title': 'Novo naročilo',
  'order.customer': 'Stranka',
  'order.products': 'Izdelki',
  'order.quantity': 'Količina',
  'order.price': 'Cena',
  'order.total': 'Skupaj',
  'order.payment': 'Plačilo',
  'order.cash': 'Gotovina',
  'order.card': 'Kartica',
  'users.title': 'Uporabniki',
  'users.name': 'Ime',
  'users.email': 'E-pošta',
  'users.role': 'Vloga',
  'users.edit': 'Uredi',
  'users.delete': 'Izbriši',
  'common.yes': 'Da',
  'common.no': 'Ne',
  'common.cancel': 'Prekliči',
  'common.save': 'Shrani',
  'common.search': 'Iskanje',
  'common.loading': 'Nalaganje...',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Prijava',
  'login.enterPin': 'Vnesite PIN',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.title': 'Registracija',
  'signup.createAccount': 'Ustvari račun',
  'signup.email': 'E-pošta',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Poročila in računovodstvo',
  'menu.systemAndCommunication': 'Sistem in komunikacija',
};
